// extracted by mini-css-extract-plugin
export default {"resp-width":"resp-width_Puw31Qfg","modal":"modal_EtfdABoa","baseStyles":"baseStyles_Kp7w3DT4"};